export const NAV_EVENT = 'app:navigate';

export const navigate = (href, { replace = false } = {}) => {
  const url = new URL(href, window.location.origin);
  if (url.origin !== window.location.origin) { window.location.href = href; return; }
  if (url.pathname === window.location.pathname && url.search === window.location.search) {
    if (url.hash) window.location.hash = url.hash;
    return;
  }
  window.history[replace ? 'replaceState' : 'pushState']({}, '', url.pathname + url.search + url.hash);
  window.dispatchEvent(new Event(NAV_EVENT));
  window.scrollTo(0, 0);
};

const isInternalLink = (a) => {
  const href = a.getAttribute('href');
  if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:')) return false;
  if (a.target && a.target !== '_self') return false;
  if (a.hasAttribute('download')) return false;
  if (href.startsWith('/api/')) return false;
  try {
    const url = new URL(href, window.location.origin);
    return url.origin === window.location.origin;
  } catch { return false; }
};

export const installLinkInterceptor = () => {
  const onClick = (e) => {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    const a = e.target.closest?.('a[href]');
    if (!a || !isInternalLink(a)) return;
    const href = a.getAttribute('href');
    const url = new URL(href, window.location.origin);
    if (url.pathname === window.location.pathname && url.hash) return;
    e.preventDefault();
    navigate(href);
  };
  document.addEventListener('click', onClick);
  return () => document.removeEventListener('click', onClick);
};
